import { isValidEmail } from "../../utils/functions";
import { showErrorToast } from "../../utils/toast";

export const useLoginEffect = () => {
    const handleLogin = (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const email = formData.get("email");
        const password = formData.get("password");

        if(isValidEmail(email) && password.length >=8) {
            return { email, password };
        }
        else {
            showErrorToast("Invalid email or password");
        }
    }

    return { handleLogin }
}